import { RevisionHistoryDialogCtrl } from '../controllers/RevisionHistoryDialogCtrl';
import { IActionContext } from '../../ts/helpers/ActionContext';
import { ResultHelper } from '../../httpClient/utils/ResultHelper';
import { DatasourceContentType, FlowContentType, IContentType, WorkbookContentType } from '../../ts/models/ContentTypes';
import { Module } from '../../ts/Module';
import { DatasourceRevisions } from '../../revisionHistoryDatasource/resources/DatasourceRevisions';
import { FlowRevisions } from '../../revisionHistoryFlow/resources/FlowRevisions';
import { WorkbookRevisions } from '../../revisionHistoryWorkbook/resources/WorkbookRevisions';
import { IContentRevision } from '../serverApi/types/IContentRevision';
import { IWorkbookRevision } from '../../revisionHistoryWorkbook/serverApi/types/IWorkbookRevision';
import { FlowRevision } from '../../revisionHistoryFlow/serverApi/types/FlowRevision';
import { IDatasourceRevision } from '../../revisionHistoryDatasource/serverApi/types/IDatasourceRevision';
import { IResult } from '../../httpClient/serverApi/types/IResponse';
import { ConfirmActionDialog, IConfirmActionDialogInstance } from '../../ts/services/ConfirmActionDialog';
import { ToasterService, ToastType } from '../../ts/services/ToasterService';

export class DeleteRevisionAction {

    public static $inject = ['$translate',
        'ConfirmActionDialog',
        'DatasourceRevisions',
        'WorkbookRevisions'];

    constructor(
        private $translate: ng.translate.ITranslateService,
        private ConfirmActionDialog: ConfirmActionDialog,
        private DatasourceRevisions: DatasourceRevisions,
        private WorkbookRevisions: WorkbookRevisions) { }

    public showDeleteWorkbookRevisionDialog(revision: IWorkbookRevision, context: IActionContext): ng.IPromise<any> {
      return this.showDeleteRevisionDialog(revision, context, WorkbookContentType);
    }

    public showDeleteDataSourceRevisionDialog(revision: IDatasourceRevision, context: IActionContext): ng.IPromise<any> {
      return this.showDeleteRevisionDialog(revision, context, DatasourceContentType);
    }

    public showDeleteFlowRevisionDialog(revision: FlowRevision, context: IActionContext): ng.IPromise<any> {
      return this.showDeleteRevisionDialog(revision, context, FlowContentType);
    }

    private showDeleteRevisionDialog(revision: IContentRevision, context: IActionContext, contentType: IContentType): ng.IPromise<any> {
      let successTextTemplate: string;

      switch (contentType) {
        case WorkbookContentType:
          successTextTemplate = 'deleteWorkbookRevisionSuccess';
          break;
        case DatasourceContentType:
          successTextTemplate = 'deleteDataSourceRevisionSuccess';
          break;
        case FlowContentType:
          successTextTemplate = 'deleteFlowRevisionSuccess';
          break;
        default:
          throw new Error(this.$translate.instant('revisionHistoryUnsupportedContentType'));
      }

      const revisionHistoryScope = (<RevisionHistoryDialogCtrl.Scope>context.scope);

      return this.ConfirmActionDialog.open({
        scope: context.scope,
        title: this.$translate.instant('deleteMessage'),
        bodyText: this.$translate.instant('deleteRevisionConfirm'),
        actionName: this.$translate.instant('deleteMessage'),
        isDeleteAction: true,
        action: (dialogInstance: IConfirmActionDialogInstance) => {
          let deleteRequest;
          switch (contentType) {
            case WorkbookContentType:
              deleteRequest = this.WorkbookRevisions.del;
              break;
            case DatasourceContentType:
              deleteRequest = this.DatasourceRevisions.del;
              break;
            case FlowContentType:
              deleteRequest = FlowRevisions.del;
              break;
            default:
              throw new Error(this.$translate.instant('revisionHistoryUnsupportedContentType'));
          }

          return deleteRequest(revision.id).then(
            (result: IResult) => {
              if (ResultHelper.hasErrors(result)) {
                ToasterService.instance.pop({ type: ToastType.Error, text: this.$translate.instant('deleteRevisionError') });
              } else {
                ToasterService.instance.pop({ type: ToastType.Info, text: this.$translate.instant(successTextTemplate) });
              }
            }
          );
        }
      }).result.then(() => {
        this.deselectDeletedRevision(revision, revisionHistoryScope);
      });
    }

    private deselectDeletedRevision(deletedRevision: IContentRevision, revisionHistoryScope: RevisionHistoryDialogCtrl.Scope) {
      if (deletedRevision.id === revisionHistoryScope.selectedItems.first().id) {
        revisionHistoryScope.selectedItems.remove(deletedRevision);
      }
    }
}

Module.instance().service('DeleteRevisionAction', DeleteRevisionAction);
